import { useCallback, useState } from "react";

export const useQuickStart = () => {
  const [activeTab, setActiveTab] = useState("projects");
  const handleToggleChange = useCallback(
    (event: React.SyntheticEvent, tab: string) => {
      setActiveTab(tab);
    },
    [],
  );
  return { activeTab, handleToggleChange };
};
